/* global Stripe */
import { Controller } from '@hotwired/stimulus'
import { emit } from '../lib/events'

export default class extends Controller {
  static targets = ['card', 'cardToken', 'purchaseButton', 'logo']

  static values = { apiKey: String, total: String }

  initialize() {
    setTimeout(() => {
      this.stripe = Stripe(this.apiKeyValue, {
        apiVersion: '2017-06-05',
      })
    }, 1000)
  }

  connect = () => {
    setTimeout(() => {
      this.setupStripeForm()
      this.cardMount()
    }, 1000)
  }

  disconnect = () => {
    this.cardUnmount()
  }

  cardMount = () => {
    if (this.hasCardTarget) {
      this.card.mount(this.cardTarget)
      this.card.on('change', (event) => {
        if (event.complete) {
          this.generateToken()
        }
      })
    }
  }

  cardUnmount = () => {
    if (this.card && this.hasCardTarget) this.card.unmount(this.cardTarget)
  }

  setupStripeForm = () => {
    const elements = this.stripe.elements()
    this.card = elements.create('card')
  }

  generateToken = () => {
    this.stripe
      .createToken(this.card)
      .then((result) => {
        if (result.error) {
          if (this.hasLogoTarget) {
            this.logoTarget.classList.add('hidden')
          }
        }
        else {
          this.populatePayerIdValues(result.token.id)
          this.revealButton()
        }
      })
  }

  populatePayerIdValues = (value) => {
    Array.from(document.querySelectorAll('input[name="order[payer_id]"]')).forEach((ele) => {
      ele.setAttribute('value', value)
    })
  }

  revealButton = () => {
    this.purchaseButtonTarget.disabled = false
    this.purchaseButtonTarget.classList.remove('opacity-40')
    this.purchaseButtonTarget.style.cursor = 'pointer'
  }

  startAnimation = () => {
    emit('openStripeCalculatingModal', { bubbles: true })
  }
}
